import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import ButtonSwitcher from "../../components/ButtonSwitcher";
import AddPerkModal from "./components/AddPerkModal";
import BroadcastOfferModal from "./components/BroadcastOfferModal";
import PerkCard from "./components/PerkCard";
import "./index.css";
import moment from "moment";
import AddButton from "../../components/AddButton";

const buttonsGroup = ["Present Perks", "Past Perks"];

export default function Perks() {
  const location = useLocation();
  const history = useHistory();
  const [tab, setTab] = useState(buttonsGroup[0]);
  const [brandData, setBrandData] = useState(null);
  const [brandId, setBrandId] = useState("");
  const [userName, setUserName] = useState("");
  const [role, setRole] = useState("");
  const [totalPerks, setTotalPerks] = useState([]);
  const [perks, setPerks] = useState([]);

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setRole(role);
      setUserName(username);
      setBrandId(brand);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (!brand_data) return;
        setBrandData(brand_data);
        Firebase.getAllPerks(brand_data.name, (perks) => {
          setTotalPerks([...perks]);
          setPerks([
            ...perks.filter((perk) => {
              const { endTime, postNow } = perk;
              if (postNow) {
                return true;
              }
              return moment(endTime).isAfter(moment(), "days") ? true : false;
            }),
          ]);
        });
      });
    }
  }, []);

  useEffect(() => {
    if (tab === "Present Perks") {
      setPerks([
        ...totalPerks.filter((perk) => {
          const { endTime, postNow } = perk;
          if (postNow) {
            return true;
          }
          return moment(endTime).isAfter(moment(), "days") ? true : false;
        }),
      ]);
    } else if (tab === "Past Perks") {
      setPerks([
        ...totalPerks.filter((perk) => {
          const { endTime, postNow } = perk;
          if (postNow) {
            return false;
          }
          return moment(endTime).isAfter(moment(), "days") ? false : true;
        }),
      ]);
    }
  }, [tab]);

  const handleSwitch = (btnName) => {
    setTab(btnName);
  };
  const renderPerks = () => {
    return (
      <div className="perk-items">
        {perks.map((item, index) => (
          <PerkCard item={item} id={index} />
        ))}
      </div>
    );
  };
  const handleClickAdd = async (perk) => {
    if (perk.postNow) {
      perk.startTime = moment().valueOf();
      perk.endTime = null;
    }
    const res = await Firebase.addPerk(perk, brandData.name);
    if (!perk.postNow) {
      let schedule_data = {
        id: res.id,
        type: "perk",
        time: perk.startTime,
        brand_name: brandData.name,
      };
      Firebase.registerSchedule(schedule_data);
    }
  };

  return (
    brandData && (
      <div id="page-container" className="perks-container">
        <Header
          username={userName}
          role={role}
          logo={brandData.logo}
          brand={brandId}
          brandName={brandData.name}
          is_property_brand={brandData.is_property_brand}
        />
        <main id="main-container">
          <ButtonSwitcher
            buttonsGroup={buttonsGroup}
            currentTab={tab}
            onSwitch={handleSwitch}
            hex={brandData ? brandData.hex : "white"}
            white={brandData ? brandData.white : false}
          />
          <div className="perks__wrapper">
            <AddButton
              label="+ Add a new offer"
              dataTarget="#add_offer_modal"
              hex={brandData.hex}
              white={brandData.white}
              className={tab === "Past Perks" ? "perks__add-btn--hidden" : ""}
            />
          </div>
          {brandData && renderPerks()}
        </main>
        <AddPerkModal
          onAdd={handleClickAdd}
          hex={brandData ? brandData.hex : "white"}
          white={brandData ? brandData.white : false}
        />
        <BroadcastOfferModal
          onAdd={handleClickAdd}
          hex={brandData ? brandData.hex : "white"}
          white={brandData ? brandData.white : false}
        />
      </div>
    )
  );
}



// WEBPACK FOOTER //
// ./src/screens/Perks/index.js